'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroup$002dSigning$002dView$0024$0024anon$002465 from "./presto.-Group-Signing-View$$anon$65.js";
import * as $j_presto$002etypes$0024proto$0024$002dGroup$002dSigning$0024 from "./presto.types$proto$-Group-Signing$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupSigningView$$anon$64() {
  this.aWz = null;
  this.aWr = null;
  this.aWs = false;
  this.aWA = null;
  this.aWB = false;
  this.aWE = null;
  this.aWx = null;
  this.aWy = false;
  this.aWt = null;
  this.aWu = false;
  this.aWv = null;
  this.aWw = false;
  this.aWC = false;
  this.aWD = false;
  this.aWz = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aWE = "GroupSigning";
}
export { $c_Lpresto_GroupSigningView$$anon$64 as $c_Lpresto_GroupSigningView$$anon$64 };
$p = $c_Lpresto_GroupSigningView$$anon$64.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupSigningView$$anon$64;
/** @constructor */
function $h_Lpresto_GroupSigningView$$anon$64() {
}
export { $h_Lpresto_GroupSigningView$$anon$64 as $h_Lpresto_GroupSigningView$$anon$64 };
$h_Lpresto_GroupSigningView$$anon$64.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.aWz;
});
$p.M = (function() {
  if ((!this.aWs)) {
    this.aWr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aWs = true;
  }
  return this.aWr;
});
$p.O = (function() {
  if ((!this.aWB)) {
    this.aWA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aWB = true;
  }
  return this.aWA;
});
$p.D = (function() {
  return this.aWE;
});
$p.t = (function() {
  if ((!this.aWy)) {
    this.aWx = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("blocked", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aWy = true;
  }
  return this.aWx;
});
$p.N = (function() {
  if ((!this.aWu)) {
    this.aWt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aq, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aWu = true;
  }
  return this.aWt;
});
$p.Q = (function() {
  if ((!this.aWw)) {
    this.aWv = new $j_presto$002e$002dGroup$002dSigning$002dView$0024$0024anon$002465.$c_Lpresto_GroupSigningView$$anon$65();
    this.aWw = true;
  }
  return this.aWv;
});
$p.v = (function() {
  if ((!this.aWD)) {
    this.aWC = false;
    this.aWD = true;
  }
  return this.aWC;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee479) => ((p) => \u03b4scrutinee479.cHQ(p)))($j_presto$002etypes$0024proto$0024$002dGroup$002dSigning$0024.$m_Lpresto_types$proto$GroupSigning$())));
});
var $d_Lpresto_GroupSigningView$$anon$64 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupSigningView$$anon$64, "presto.GroupSigningView$$anon$64", ({
  Jk: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupSigningView$$anon$64 as $d_Lpresto_GroupSigningView$$anon$64 };
//# sourceMappingURL=presto.-Group-Signing-View$$anon$64.js.map
